import { render, staticRenderFns } from "./orderDetailDialog.vue?vue&type=template&id=259b5d2c&scoped=true"
import script from "./orderDetailDialog.vue?vue&type=script&lang=js"
export * from "./orderDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259b5d2c",
  null
  
)

export default component.exports